import React from 'react';
import {
  SPLIT_SEPARATORS,
  Action,
  CopyToClipboard,
  withInject,
} from '@piwikpro/platform';
import {
  Stack,
  Trans,
  withTranslation,
} from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { TrackerSettings } from '../../../TrackerSettings';

export interface SearchCategoryAndQueryParamsProps {
  appId: string
  globalAndAppSearchQueryTrackerSettings: Array<string | object>
  globalAndAppSearchCategoryTrackerSettings: Array<string | object>
  appSearchQueryTrackerSettings: string[]
  appSearchCategoryTrackerSettings: string[]
  trackerSettings: TrackerSettings
  validation: FormValidator
  t: (key: string) => string
}

interface FormValues {
  [key: string]: string[]
}

class SearchCategoryAndQueryParams extends React.Component<SearchCategoryAndQueryParamsProps> {
  constructor(props: SearchCategoryAndQueryParamsProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: FormValues, {
    setSubmitting,
    setErrors,
    setFieldValue,
  }: {
    setSubmitting: Function
    setErrors: Function
    setFieldValue: Function
  }) {
    const {
      trackerSettings,
      appId,
      globalAndAppSearchQueryTrackerSettings,
      globalAndAppSearchCategoryTrackerSettings,
    } = this.props;
    const field = Object.keys(values)[0];
    const valuesWithoutGlobals = {
      [field]: values[field].filter((element: any) => !element.disabled),
    };

    try {
      await trackerSettings.updateSettingsForApp(appId, valuesWithoutGlobals);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        field,
        field === 'site_search_query_params'
          ? globalAndAppSearchQueryTrackerSettings
          : globalAndAppSearchCategoryTrackerSettings,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const {
      appSearchCategoryTrackerSettings,
      appSearchQueryTrackerSettings,
      globalAndAppSearchCategoryTrackerSettings,
      globalAndAppSearchQueryTrackerSettings,
      validation,
      t,
    } = this.props;

    return (
      <Stack vertical horizontalAlignment="fill">
        <Stack.Item>
          <Stack vertical spacing="narrow" horizontalAlignment="fill">
            <Stack.Item>
              <Action.AutoSavedTagsInputControl
                id="app-settings-tracking-query-params"
                label={t('apps.details.settings.tracking.site-search.query-params.title')}
                info={(
                  <div style={{ display: 'inline-block' }}>
                    <Trans
                      i18nKey="apps.details.settings.tracking.site-search.query-params.info"
                      components={[
                        <b>text</b>,
                      ]}
                    />
                  </div>
                )}
                name="site_search_query_params"
                initialValue={globalAndAppSearchQueryTrackerSettings}
                validationSchema={validation.createValidationSchema(validators => ({
                  site_search_query_params: validators.trackerSettings.siteSearchQueryParams,
                }))}
                splitSeparators={SPLIT_SEPARATORS}
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
            <Stack.Item>
              <CopyToClipboard text={appSearchQueryTrackerSettings?.join('\n')} />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack vertical spacing="narrow" horizontalAlignment="fill">
            <Stack.Item>
              <Action.AutoSavedTagsInputControl
                id="app-settings-tracking-categories"
                label={t('apps.details.settings.tracking.site-search.query-category.title')}
                info={(
                  <div style={{ display: 'inline-block', marginTop: '4px' }}>
                    <Trans
                      i18nKey="apps.details.settings.tracking.site-search.query-category.info"
                      components={[
                        <b>text</b>,
                      ]}
                    />
                  </div>
                )}
                name="site_search_category_params"
                initialValue={globalAndAppSearchCategoryTrackerSettings}
                validationSchema={validation.createValidationSchema(validators => ({
                  site_search_category_params: validators.trackerSettings.siteSearchCategoryParams,
                }))}
                splitSeparators={SPLIT_SEPARATORS}
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
            <Stack.Item>
              <CopyToClipboard text={appSearchCategoryTrackerSettings?.join('\n')} />
            </Stack.Item>
          </Stack>
        </Stack.Item>
      </Stack>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(
  withTranslation(['administration'])(SearchCategoryAndQueryParams as any),
);
